import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import TreeSection from './TreeSection';
import {useGetProductionSetList} from '../../../hooks/corpus/useCorpus';
import {t} from 'i18next';

const ProductionSets = () => {
  const securityGroupId =
    useSelector(
      (state: RootState) => state.roleImpersonation.prefill.securityGroup?.id
    ) ?? 0;
  return (
    <TreeSection
      fetchHook={useGetProductionSetList}
      securityGroupId={securityGroupId}
      type={t('corpus.sectionType.productionSets')}
    />
  );
};

export default ProductionSets;
